import React, { useEffect, useState } from "react";
import { LifeBuoy, X } from "lucide-react";
import SupportCard from "./SupportCard";

/**
 * Site-wide floating help button (bottom-right). Opens a glass modal
 * containing the SupportCard. Hidden on small screens to avoid covering
 * the mobile UI; available globally otherwise.
 */
export default function FloatingHelp() {
  const [open, setOpen] = useState(false);

  // close on Esc
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Open support"
        title="Need help?"
        className="hidden sm:inline-flex fixed bottom-20 right-5 z-[80] items-center gap-2 px-4 py-2.5 rounded-full border border-white/10 bg-black/70 backdrop-blur-xl text-white/90 text-sm tracking-tight hover:border-[var(--bull)]/60 hover:text-white transition-all shadow-[0_8px_40px_rgba(0,0,0,0.45)]"
        style={{ boxShadow: "0 0 0 0 rgba(0,255,156,0.0), 0 10px 30px rgba(0,0,0,0.5)" }}
        data-testid="floating-help-btn"
      >
        <span className="relative inline-flex">
          <LifeBuoy className="w-4 h-4 text-[var(--bull)]" />
          <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-[var(--bull)] pulse-dot" />
        </span>
        Help
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[90] bg-black/75 backdrop-blur-2xl flex items-center justify-center p-4 fade-in"
          onClick={() => setOpen(false)}
          data-testid="floating-help-modal"
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-5 right-5 text-white/50 hover:text-white p-2"
            aria-label="Close support"
            data-testid="floating-help-close"
          >
            <X className="w-5 h-5" />
          </button>
          <div
            className="relative w-full max-w-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <SupportCard compact />
          </div>
        </div>
      )}
    </>
  );
}
